var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreativity = function SvgCreativity(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 216,
    viewBox: "0 0 214 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Creativity"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Right",
    d: "M205.179 172.975H184.412C183.893 172.975 183.466 172.242 183.466 171.335V143.638C183.466 142.732 183.893 141.999 184.412 141.999H205.179C205.952 141.999 206.405 143.505 205.952 144.585L200.993 156.541C200.753 157.114 200.753 157.873 200.993 158.433L205.952 170.389C206.405 171.469 205.952 172.975 205.179 172.975Z",
    fill: "#4539FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Left",
    d: "M8.9535 141.999H29.7196C30.2394 141.999 30.666 142.732 30.666 143.638V171.335C30.666 172.242 30.2394 172.975 29.7196 172.975H8.9535C8.18044 172.975 7.72726 171.469 8.18044 170.389L13.1387 158.433C13.3786 157.86 13.3786 157.1 13.1387 156.541L8.18044 144.585C7.72726 143.505 8.18044 141.999 8.9535 141.999Z",
    fill: "#4539FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back",
    filter: "url(#filter0_d_1241_129244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.668 58.0415V155.781C24.668 161.992 28.6799 167.483 34.5845 169.376L102.708 191.195C105.533 192.101 108.585 192.101 111.411 191.195L179.534 169.376C185.439 167.483 189.451 161.992 189.451 155.781V58.0415C189.451 51.6837 185.252 46.0989 179.134 44.3262L111.011 24.6531C108.426 23.9067 105.68 23.9067 103.094 24.6531L34.9711 44.3262C28.8665 46.0856 24.6547 51.6837 24.6547 58.0415H24.668Z",
    fill: "url(#paint0_linear_1241_129244)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.9995 61.8135V152.155C29.9995 158.273 33.9581 163.698 39.7828 165.564L102.774 185.744C105.573 186.637 108.572 186.637 111.358 185.744L174.349 165.564C180.174 163.698 184.133 158.273 184.133 152.155V61.8135C184.133 55.549 179.987 50.0309 173.963 48.2849L110.971 30.0912C108.426 29.3581 105.707 29.3581 103.161 30.0912L40.1693 48.2849C34.1447 50.0309 29.9995 55.5357 29.9995 61.8135Z",
    fill: "url(#paint1_linear_1241_129244)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Base"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1241_129244",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 29,
    width: 156,
    height: 158
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Front-2",
    d: "M29.9995 61.8135V152.155C29.9995 158.273 33.9581 163.698 39.7828 165.564L102.774 185.744C105.573 186.637 108.572 186.637 111.358 185.744L174.349 165.564C180.174 163.698 184.133 158.273 184.133 152.155V61.8135C184.133 55.549 179.987 50.0309 173.963 48.2849L110.971 30.0912C108.426 29.3581 105.707 29.3581 103.161 30.0912L40.1693 48.2849C34.1447 50.0309 29.9995 55.5357 29.9995 61.8135Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1241_129244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M107.066 236.166C161.841 236.166 206.245 209.927 206.245 177.56C206.245 145.193 161.841 118.954 107.066 118.954C52.2911 118.954 7.88721 145.193 7.88721 177.56C7.88721 209.927 52.2911 236.166 107.066 236.166Z",
    fill: "#F28723"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Stars",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.6495 126.058C41.5487 126.058 43.0883 124.518 43.0883 122.619C43.0883 120.72 41.5487 119.18 39.6495 119.18C37.7503 119.18 36.2107 120.72 36.2107 122.619C36.2107 124.518 37.7503 126.058 39.6495 126.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M168.965 123.046L166.965 126.324C166.659 126.831 165.912 126.831 165.592 126.324L163.593 123.046C163.433 122.792 163.433 122.472 163.593 122.206L165.592 118.927C165.899 118.42 166.645 118.42 166.965 118.927L168.965 122.206C169.125 122.459 169.125 122.792 168.965 123.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M175.389 115.981L173.816 118.554C173.576 118.954 172.99 118.954 172.736 118.554L171.164 115.981C171.044 115.781 171.044 115.528 171.164 115.328L172.736 112.756C172.976 112.356 173.563 112.356 173.816 112.756L175.389 115.328C175.509 115.528 175.509 115.781 175.389 115.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M58.0164 63.5595L56.8435 65.4655C56.6569 65.7588 56.2304 65.7588 56.0438 65.4655L54.8842 63.5595C54.7909 63.4129 54.7909 63.2263 54.8842 63.0664L56.0438 61.1604C56.2304 60.8671 56.6569 60.8671 56.8435 61.1604L58.0164 63.0664C58.1097 63.213 58.1097 63.3996 58.0164 63.5595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M67.7863 54.0562L65.5205 57.7616C65.1606 58.3347 64.3209 58.3347 63.9743 57.7616L61.7084 54.0562C61.5352 53.7629 61.5352 53.4031 61.7084 53.1098L63.9743 49.4045C64.3342 48.8313 65.1739 48.8313 65.5205 49.4045L67.7863 53.1098C67.9596 53.4031 67.9596 53.7629 67.7863 54.0562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M50.9788 120.78C51.9358 120.78 52.7116 120.004 52.7116 119.047C52.7116 118.09 51.9358 117.314 50.9788 117.314C50.0219 117.314 49.2461 118.09 49.2461 119.047C49.2461 120.004 50.0219 120.78 50.9788 120.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M40.5292 106.571C41.9426 106.571 43.0883 105.425 43.0883 104.012C43.0883 102.599 41.9426 101.453 40.5292 101.453C39.1158 101.453 37.9701 102.599 37.9701 104.012C37.9701 105.425 39.1158 106.571 40.5292 106.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M169.564 110.85L168.151 113.156C167.925 113.515 167.405 113.515 167.192 113.156L165.779 110.85C165.672 110.663 165.672 110.437 165.779 110.263L167.192 107.957C167.418 107.598 167.938 107.598 168.151 107.957L169.564 110.263C169.671 110.45 169.671 110.676 169.564 110.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M175.482 64.6126C176.829 64.6126 177.921 63.5205 177.921 62.1734C177.921 60.8263 176.829 59.7343 175.482 59.7343C174.135 59.7343 173.043 60.8263 173.043 62.1734C173.043 63.5205 174.135 64.6126 175.482 64.6126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M165.699 53.0698C166.656 53.0698 167.432 52.2941 167.432 51.3371C167.432 50.3801 166.656 49.6044 165.699 49.6044C164.742 49.6044 163.966 50.3801 163.966 51.3371C163.966 52.2941 164.742 53.0698 165.699 53.0698Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shine"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1241_129244",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 166,
    height: 168
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M24.6681 58.1081V155.701C24.6681 161.952 28.7067 167.483 34.6513 169.389L102.681 191.182C105.533 192.101 108.599 192.101 111.451 191.182L179.481 169.389C185.439 167.483 189.464 161.952 189.464 155.701V58.1081C189.464 51.7103 185.226 46.0723 179.081 44.2996L111.051 24.6531C108.452 23.9067 105.68 23.9067 103.081 24.6531L35.0511 44.2996C28.9066 46.0723 24.6681 51.7103 24.6681 58.1081Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1241_129244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.15,
    d: "M16.1111 241.764C13.512 234.513 12.2058 230.421 9.60669 221.278C27.0273 208.349 45.7408 199.605 64.2677 188.596C83.8608 176.96 99.762 161.752 117.063 147.05C152.877 116.648 179.241 111.29 224.532 123.459C227.131 125.791 228.437 126.991 231.036 129.59C184.866 115.955 158.821 126.777 123.567 157.767C89.2457 187.956 48.4332 209.895 16.0978 241.751L16.1111 241.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.15,
    d: "M6.10123 225.596C-9.73326 197.526 -16.7708 164.458 -24.1549 133.482C23.2153 134.242 48.5131 110.49 83.3144 81.4599C118.835 51.8302 146.519 43.9796 190.784 58.6679C201.26 69.0776 211.31 79.314 221.04 90.4301C175.002 68.5711 145 98.494 113.571 130.629C79.569 165.404 41.4623 192.741 6.10123 225.596Z",
    fill: "white"
  })))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M97.8159 126.098H116.343C116.943 126.098 117.436 126.591 117.436 127.191V143.612C117.436 145.824 115.636 147.624 113.424 147.624H100.722C98.509 147.624 96.7096 145.824 96.7096 143.612V127.191C96.7096 126.591 97.2028 126.098 97.8025 126.098H97.8159Z",
    fill: "url(#paint2_linear_1241_129244)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M122.034 118.674H92.1246C91.7381 118.674 91.4315 118.98 91.4315 119.367V122.646H92.3379V124.725H91.4315V128.15H92.3379V130.23H91.4315V133.655H92.4178L92.8444 135.734H91.4315V137.427C91.4315 140.773 94.1372 143.478 97.4827 143.478H116.663C120.008 143.478 122.714 140.773 122.714 137.427V135.734H121.301L121.728 133.655H122.714V130.23H121.808V128.15H122.714V124.725H121.808V122.646H122.714V119.367C122.714 118.98 122.407 118.674 122.021 118.674H122.034Z",
    fill: "url(#paint3_linear_1241_129244)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M101.148 118.674C101.148 114.462 100.788 110.263 100.069 106.118L98.2158 95.3884",
    stroke: "#7F6A13",
    strokeWidth: 1.33287,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M113.011 118.674C113.011 114.462 113.37 110.263 114.09 106.118L115.943 95.3884",
    stroke: "#7F6A13",
    strokeWidth: 1.33287,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M95.8966 94.9619C95.8966 94.9619 99.9219 96.8945 102.987 95.9082C106.053 94.9219 105.8 91.2698 104.454 90.2035C103.094 89.1372 100.708 90.8033 101.121 93.3624C101.588 96.1615 104.534 96.588 108.279 96.6146C111.491 96.6413 113.331 94.2954 112.624 91.7497C111.918 89.2039 108.332 89.9236 108.892 93.1358C109.452 96.3481 113.877 97.0411 118.222 95.2551",
    stroke: "#7F6A13",
    strokeWidth: 1.33287,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M134.177 85.7252C134.177 70.6371 121.834 58.428 106.693 58.6279C92.0978 58.8278 80.182 70.757 79.9821 85.3519C79.8888 92.5894 82.6211 99.1871 87.1662 104.092C90.7117 107.931 92.631 112.982 92.631 118.194V118.66H121.514V118.26C121.514 112.929 123.58 107.851 127.152 103.905C131.511 99.0938 134.163 92.7227 134.163 85.7252H134.177Z",
    stroke: "#FDF0B3",
    strokeWidth: 2.66574,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M121.808 122.632H92.3379V124.712H121.808V122.632Z",
    fill: "#7B60F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M121.808 128.137H92.3379V130.216H121.808V128.137Z",
    fill: "#7B60F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M92.8444 135.721H121.314C121.514 135.055 121.661 134.362 121.741 133.642H92.4178C92.4978 134.362 92.6444 135.055 92.8444 135.721Z",
    fill: "#7B60F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M94.5504 139.16C95.1235 139.946 95.79 140.639 96.5364 141.239H117.622C118.369 140.639 119.035 139.946 119.608 139.16H94.5637H94.5504Z",
    fill: "#7B60F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M89.6454 68.5178C97.5493 60.9871 105.12 60.9871 105.12 60.9871L82.6345 83.6725C82.6345 83.6725 82.0614 76.8482 89.6321 68.5178H89.6454Z",
    fill: "url(#paint4_linear_1241_129244)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M130.418 93.3491C126.833 103.652 120.102 107.131 120.102 107.131L129.712 76.6749C129.712 76.6749 133.35 82.4862 130.431 93.3624L130.418 93.3491Z",
    fill: "url(#paint5_linear_1241_129244)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M107.079 52.4967V45.5125",
    stroke: "#FDF0B3",
    strokeWidth: 2.66574,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M83.5942 62.2267L78.6493 57.2817",
    stroke: "#FDF0B3",
    strokeWidth: 2.66574,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M73.8642 85.6985H66.88",
    stroke: "#FDF0B3",
    strokeWidth: 2.66574,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M83.5809 109.184L78.636 114.129",
    stroke: "#FDF0B3",
    strokeWidth: 2.66574,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M130.538 109.197L135.483 114.142",
    stroke: "#FDF0B3",
    strokeWidth: 2.66574,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M140.281 85.7251H147.265",
    stroke: "#FDF0B3",
    strokeWidth: 2.66574,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M130.565 62.24L135.496 57.295",
    stroke: "#FDF0B3",
    strokeWidth: 2.66574,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M184.786 178.599C133.284 160.206 84.5539 160.739 33.545 180.465C31.6923 181.279 29.573 180.639 28.8133 178.986C26.1875 168.843 24.988 163.725 22.7887 153.448C22.0556 151.795 23.2286 149.69 25.4145 148.797C80.6619 129.363 133.204 128.95 188.771 147.477C190.984 148.29 192.263 150.356 191.623 152.049C191.117 162.112 190.69 167.11 189.504 177.013C188.798 178.679 186.692 179.373 184.799 178.599H184.786Z",
    fill: "#4539FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M62.9881 152.822C63.2547 152.035 63.6945 151.382 64.321 150.849C64.9474 150.316 65.7071 149.983 66.6002 149.809C67.6931 149.61 68.6794 149.729 69.5591 150.156C70.4388 150.583 71.1053 151.276 71.5584 152.222L69.0926 152.675C68.8394 152.329 68.5195 152.075 68.1463 151.942C67.7731 151.809 67.3732 151.769 66.9467 151.849C66.2536 151.982 65.7471 152.315 65.4006 152.875C65.054 153.435 64.9607 154.115 65.1207 154.914C65.2806 155.714 65.6005 156.327 66.1203 156.727C66.6402 157.127 67.2399 157.26 67.933 157.14C68.3595 157.06 68.7194 156.887 69.026 156.634C69.3326 156.381 69.5325 156.034 69.6391 155.607L72.1049 155.154C72.0249 156.194 71.6517 157.074 70.9853 157.793C70.3189 158.513 69.4258 158.966 68.3329 159.166C67.4399 159.326 66.6135 159.273 65.8271 159.006C65.054 158.74 64.4009 158.287 63.8811 157.647C63.3613 157.007 63.0147 156.234 62.8415 155.328C62.6682 154.421 62.7215 153.568 62.9881 152.782V152.822Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M79.6356 157.34L77.2231 154.101L76.6766 154.181L77.1565 157.687L74.9039 157.993L73.6377 148.717L77.423 148.197C78.1561 148.103 78.7959 148.143 79.3424 148.33C79.8889 148.517 80.3287 148.81 80.6353 149.223C80.9551 149.636 81.1417 150.116 81.2217 150.663C81.3017 151.276 81.2084 151.849 80.9285 152.382C80.6486 152.915 80.1821 153.328 79.529 153.622L82.1681 157.007L79.6223 157.354L79.6356 157.34ZM76.4634 152.582L77.8629 152.395C78.2761 152.342 78.5693 152.195 78.7559 151.969C78.9292 151.742 78.9958 151.436 78.9425 151.062C78.8892 150.716 78.7559 150.449 78.516 150.276C78.2761 150.103 77.9562 150.049 77.543 150.103L76.1435 150.289L76.4634 152.582Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M85.9534 149.036L86.14 150.916L89.179 150.623L89.3522 152.369L86.3133 152.662L86.5132 154.701L89.952 154.368L90.1253 156.181L84.4206 156.727L83.5276 147.41L89.2323 146.864L89.4055 148.677L85.9667 149.01L85.9534 149.036Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M98.1491 154.048L94.657 154.235L94.1905 155.914L91.8047 156.034L94.6837 146.517L97.3228 146.371L101.201 155.541L98.7889 155.674L98.1358 154.048H98.1491ZM97.4694 152.329L96.1365 148.97L95.1768 152.449L97.4827 152.329H97.4694Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M109.732 146.104V147.93L107.266 147.957L107.333 155.488H105.053L104.987 147.983L102.508 148.01V146.184L109.732 146.117V146.104Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M114.37 146.224L114.144 155.581L111.864 155.528L112.091 146.171L114.37 146.224Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M125.979 146.811L122.114 155.954L119.262 155.781L116.503 146.237L118.929 146.384L120.821 153.568L123.567 146.651L125.979 146.797V146.811Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M130.418 147.264L129.512 156.58L127.246 156.354L128.152 147.037L130.418 147.264Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M139.895 148.41L139.655 150.223L137.202 149.903L136.229 157.367L133.963 157.074L134.936 149.61L132.484 149.29L132.724 147.477L139.895 148.41Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M150.184 150.156L145.906 155.767L145.373 158.82L143.133 158.42L143.667 155.368L141.561 148.637L144.106 149.076L145.213 153.248L147.665 149.703L150.184 150.143V150.156Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1241_129244",
    x: 0.66301,
    y: 0.101608,
    width: 212.779,
    height: 215.765,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.9958
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1241_129244"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1241_129244",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1241_129244",
    x1: 107.066,
    y1: 104.865,
    x2: 107.066,
    y2: 269.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1241_129244",
    x1: 107.066,
    y1: 252.747,
    x2: 107.066,
    y2: -51.2672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FF5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFAE4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF5696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1241_129244",
    x1: 107.079,
    y1: 139.36,
    x2: 107.079,
    y2: 151.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#46356D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E488F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1241_129244",
    x1: 107.079,
    y1: 117.288,
    x2: 107.079,
    y2: 148.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B60F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61D4ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1241_129244",
    x1: 88.046,
    y1: 66.4918,
    x2: 94.0972,
    y2: 72.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1241_129244",
    x1: 132.766,
    y1: 94.3913,
    x2: 124.616,
    y2: 91.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreativity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "creativity.6ca76d0.svg";